export const GROUP_MENU_ACTION = {
    GROUP_MENU_CLOSED : 'GROUP_MENU_CLOSED',
    BULK_UPLOAD : 'BULK_UPLOAD',
    BULK_LOGS : 'BULK_LOGS',
    JOIN_LOGS : 'JOIN_LOGS'
} 